import {cpServiceV2Put} from 'api';
import {sendSentryException} from 'utils/error-handling';
import {camelizeKeys} from 'utils/format-strings';
import {
    DiscountItem,
    MultiDayDiscountsResponseData,
    RawMultiDayDiscountsResponse,
    UpdateMultiDayDiscountRequestParams,
} from 'api/rates/multi-day-discounts/multi-day-discounts.types';

/**
 * Formats the request data for updating multi-day discounts.
 */
const formatMultiDayDiscountsRequest = (discounts: DiscountItem[]) => {
    const formattedDiscounts = discounts.map((discount: DiscountItem) => ({
        amount: discount.amount,
        duration: discount.duration,
    }));

    return formattedDiscounts;
};

/**
 * Formats the response data for multi-day discounts.
 */
const formatMultiDayDiscountsResponse = (
    data: RawMultiDayDiscountsResponse
) => {
    const formattedResponse: MultiDayDiscountsResponseData = camelizeKeys(data);

    return formattedResponse;
};

/**
 * Updates multi-day discounts for a facility's rating rule group.
 */
const updateMultiDayDiscounts = async ({
    facilityId,
    ruleGroupId,
    discounts,
}: UpdateMultiDayDiscountRequestParams) => {
    try {
        const formattedDiscounts = formatMultiDayDiscountsRequest(discounts);

        const response = await cpServiceV2Put<RawMultiDayDiscountsResponse>(
            `facilities/${facilityId}/rating-rule-groups/${ruleGroupId}/discounts`,
            {discounts: formattedDiscounts},
            {}
        );

        const formattedResponse = formatMultiDayDiscountsResponse(
            response.data.data
        );

        return formattedResponse;
    } catch (error) {
        sendSentryException(error);
        throw error;
    }
};

export default updateMultiDayDiscounts;
